import React, { useEffect, useState } from "react";
import { getArchives, deleteArchive } from "./archiveManager";
import "./ArchivePage.css";

export default function ArchivesPage({ goTo }) {
  const [archives, setArchives] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    async function load() {
      const all = await getArchives();
      setArchives(all);
    }
    load();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer cette archive ?")) return;
    await deleteArchive(id);
    const refreshed = await getArchives();
    setArchives(refreshed);
  };

  const filteredArchives = archives.filter((a) =>
    a.clientName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="archives-container">
      <h1>Archives</h1>

      <input
        type="text"
        placeholder="🔍 Rechercher un client..."
        className="search-bar"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <div className="archive-grid">
        {filteredArchives.map((item) => (
          <div key={item.id} className="archive-card glass-card">
            <div className="archive-header">
              {item.photoBase64 && (
                <img
                  src={item.photoBase64}
                  alt="client"
                  className="archive-thumb"
                />
              )}
              <h3 className="archive-name">{item.clientName}</h3>
            </div>

            <div className="archive-info">
              <p><strong>OG :</strong> {item.results?.DP_OG ?? "—"} mm</p>
              <p><strong>OD :</strong> {item.results?.DP_OD ?? "—"} mm</p>
              <p><strong>DP Total :</strong> {item.results?.DP_total ?? "—"} mm</p>
              <p><strong>HG :</strong> {item.results?.H_OG ?? "—"} mm</p>
              <p><strong>HD :</strong> {item.results?.H_OD ?? "—"} mm</p>
              {item.thicknessStudy?.updatedAt && (
                <p><strong>Étude :</strong> {new Date(item.thicknessStudy.updatedAt).toLocaleDateString()}</p>
              )}
            </div>

            <p className="archive-date">
              {new Date(item.date).toLocaleDateString()}
            </p>

            <div className="archive-actions archive-actions--triple">
              <button className="open-btn" onClick={() => goTo("mesures", item)}>
                📄 Ouvrir
              </button>

              <button className="open-btn thickness-btn" onClick={() => goTo("thickness", item)}>
                📐 Épaisseurs
              </button>

              <button className="delete-btn" onClick={() => handleDelete(item.id)}>
                🗑 Supprimer
              </button>
            </div>
          </div>
        ))}
      </div>

      <button className="back-btn" onClick={() => goTo("home")}>
        ⬅ Retour
      </button>
    </div>
  );
}
